module.exports = __webpack_public_path__ + "img/ZHWLRJKF_3.c331301d.jpg";